import { useFinancialStatus } from '../../hooks/FinancialStatusContext';
import WhatsappBtn from '../../modules/licensees/pages/Payment/WhatsappButton';
import {
  Container,
  PrincipalText,
  SecondaryText,
  ActionButton,
} from "./styles";

const OverduePayment = () => {
  const { overdueBill } = useFinancialStatus();

  return (
    <Container>
      <PrincipalText>
        Pendência de Pagamento Identificada
      </PrincipalText>
      <SecondaryText>
        Identificamos que sua fatura deste mês está vencida. Para garantir que seu acesso não seja interrompido, por favor, regularize sua situação o mais breve possível.
      </SecondaryText>

      {true && (
        <ActionButton
          href={overdueBill?.payment_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Pagar Fatura Agora
        </ActionButton>
      )}
      <WhatsappBtn />
    </Container>
  )
}

export default OverduePayment;
